module.exports = __webpack_public_path__ + "img/close-icon.8289eb4f.svg";